import "./brokerCryptoTest.scss";
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
const { formatText } = require('core/i18n').i18n;

import BrokerCryptoFrame from "../brokerCryptoFrame/brokerCryptoFrame";
import BrokerCryptoTestDocumentation from 'mifid/components/brokerCryptoTest/brokerCryptoTestDocumentation/brokerCryptoTestDocumentation';
import BrokerCryptoTestSignDocumentation from "../brokerCryptoTestSignDocumentation/brokerCryptoTestSignDocumentation";
import BrokerCryptoTestSummary from 'mifid/components/brokerCryptoTest/brokerCryptoTestSummary/brokerCryptoTestSummary';
import BrokerCryptoTestContainer from 'mifid/components/brokerCryptoTest/brokerCryptoTestContainer/brokerCryptoTestContainer';
import { useCryptoTest } from 'ok-mifid/components/brokerCryptoTest/brokerCryptoTest/hooks/useCryptoTest';
import BrokerCryptoTestFooter from 'ok-mifid/components/brokerCryptoTest/brokerCryptoTestFooter/brokerCryptoTestFooter';
import BrokerCryptoToast from 'ok-mifid/components/brokerCryptoTest/brokerCryptoToast/brokerCryptoToast';

import BrokerConvenienceMiFIDTestActions from 'mifid/actions/brokerConvenienceMiFIDTest';

import { CRYPTO_TEST_STATES } from 'mifid/constants/constants'
const { TEST_IN_PROGRESS, TEST_SUMMARY, READ_DOCUMENTATION, SIGN_DOCUMENTATION } = CRYPTO_TEST_STATES;

const BrokerCryptoTest = ({
    history,
    immBrokerConvenienceMiFIDTest,
    updateAnswer,
    setCryptoTestIndex,
    setCryptoTestState,
    setCryptoTestLength,
    setEditionMode,
    insertTestWithoutToken,
    closeCryptoResultModal,
    onMiFIDResultDisplayed,
    getCryptoDocumentation,
    requestCryptoDocumentation,
    signDocument,
    getCurrentTestScore,
}) => {

    const {
        testState,
        testQuestion,
        previousAnseredQuestion,
        unansweredQuestions,
        buildTest,
        currentQuestionIndex,
        onClickAnswer,
        goToPreviousQuestion,
        goToEditQuestion,
        isEditing,
        questionsToEdit,
        showToast,
        handleCloseToast,
        handleModalClick,
        isModalDocumentationOpen,
        openModalDocumentation,
        closeModalDocumentation,
        goToPurchaseFlow,
        goToNextStep,
        currentQuestionIsAwnsered,
        goToSignDocumentation
    } = useCryptoTest({
        history,
        immBrokerConvenienceMiFIDTest,
        updateAnswer,
        setCryptoTestIndex,
        setCryptoTestState,
        setCryptoTestLength,
        setEditionMode,
        insertTestWithoutToken,
        closeCryptoResultModal,
        onMiFIDResultDisplayed,
        requestCryptoDocumentation,
    });

    useEffect(() => {
        buildTest(immBrokerConvenienceMiFIDTest,);
    }, []);

    useEffect(() => {
        if(testState !== TEST_SUMMARY) {
            handleCloseToast();
        }
    }, [testState]);

    const isModalOpen = immBrokerConvenienceMiFIDTest.getIn(['test', 'cryptoModalResult'])
    const renderContent = () => {
        switch (testState) {
            case TEST_IN_PROGRESS:
                return (
                    <BrokerCryptoTestContainer
                        currentQuestionIndex={currentQuestionIndex}
                        immTestQuestion={isEditing ? questionsToEdit : testQuestion}
                        immBrokerConvenienceMiFIDTest={immBrokerConvenienceMiFIDTest}
                        onClickAnswer={onClickAnswer}
                    />
                );
            case TEST_SUMMARY:
                return (
                    <BrokerCryptoTestSummary
                        previousAnseredQuestion={previousAnseredQuestion}
                        unansweredQuestions={unansweredQuestions}
                        goToEditQuestion={goToEditQuestion}
                        isModalOpen={isModalOpen}
                        handleModalClick={handleModalClick}
                        immBrokerConvenienceMiFIDTest={immBrokerConvenienceMiFIDTest}
                    />
                );
            case READ_DOCUMENTATION:
                return (
                    <BrokerCryptoTestDocumentation
                        immBrokerConvenienceMiFIDTest={immBrokerConvenienceMiFIDTest}
                        isModalDocumentationOpen={isModalDocumentationOpen}
                        closeModalDocumentation={closeModalDocumentation}
                        getCryptoDocumentation={getCryptoDocumentation}
                        goToSignDocumentation={goToSignDocumentation}
                        goToPurchaseFlow={goToPurchaseFlow}
                        requestCryptoDocumentation={requestCryptoDocumentation}
                    />

                );
            case SIGN_DOCUMENTATION:
                return (
                    <BrokerCryptoTestSignDocumentation
                        history={history}
                        signDocument={signDocument}
                        immBrokerConvenienceMiFIDTest={immBrokerConvenienceMiFIDTest}
                        goToPurchaseFlow={goToPurchaseFlow}
                    />
                );
            default:
                return <></>;
        }
    };

    if (testState === SIGN_DOCUMENTATION) {
        return renderContent();
    }

    return (
        <div className="crypto-test__container">
            <BrokerCryptoFrame 
                immBrokerConvenienceMiFIDTest={immBrokerConvenienceMiFIDTest}
                title={formatText("brokerCryptoTest-frameTitle")}
            >
                {renderContent()}
                <BrokerCryptoTestFooter
                    testState={testState}
                    goToPreviousQuestion={goToPreviousQuestion}
                    currentQuestionIndex={currentQuestionIndex}
                    cancelPath={immBrokerConvenienceMiFIDTest.get('cancelPath')}
                    insertTestWithoutToken={insertTestWithoutToken}
                    getCurrentTestScore={getCurrentTestScore}
                    openModalDocumentation={openModalDocumentation}
                    history={history}
                    goToNextStep={goToNextStep}
                    currentQuestionIsAwnsered={currentQuestionIsAwnsered}
                    immBrokerConvenienceMiFIDTest={immBrokerConvenienceMiFIDTest}
                />
                {<BrokerCryptoToast
                    message={formatText('brokerCryptoTest-toastMessage')}
                    show={showToast}
                    onClose={handleCloseToast}
                />}
            </BrokerCryptoFrame>
        </div>
    );
}

BrokerCryptoTest.propTypes = {
    history: PropTypes.object.isRequired,
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired,
    updateAnswer: PropTypes.func.isRequired,
    setCryptoTestIndex: PropTypes.func.isRequired,
    setCryptoTestState: PropTypes.func.isRequired,
    setCryptoTestLength: PropTypes.func.isRequired,
    setEditionMode: PropTypes.func.isRequired,
    insertTestWithoutToken: PropTypes.func.isRequired,
    closeCryptoResultModal: PropTypes.func.isRequired,
    onMiFIDResultDisplayed: PropTypes.func.isRequired,
    requestCryptoDocumentation: PropTypes.func.isRequired,
    getCryptoDocumentation: PropTypes.func.isRequired,
    signDocument: PropTypes.func.isRequired,
    getCurrentTestScore: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    immBrokerConvenienceMiFIDTest: state.brokerConvenienceMiFIDTest,
})

const mapDispatchToProps = {
    updateAnswer: BrokerConvenienceMiFIDTestActions.updateAnswer,
    setCryptoTestIndex: BrokerConvenienceMiFIDTestActions.setCryptoTestIndex,
    setCryptoTestState: BrokerConvenienceMiFIDTestActions.setCryptoTestState,
    setCryptoTestLength: BrokerConvenienceMiFIDTestActions.setCryptoTestLength,
    setEditionMode: BrokerConvenienceMiFIDTestActions.setEditionMode,
    insertTestWithoutToken: BrokerConvenienceMiFIDTestActions.insertTestWithoutToken,
    closeCryptoResultModal: BrokerConvenienceMiFIDTestActions.closeCryptoResultModal,
    onMiFIDResultDisplayed: BrokerConvenienceMiFIDTestActions.resultDisplayed,
    requestCryptoDocumentation: BrokerConvenienceMiFIDTestActions.requestCryptoDocumentation,
    getCryptoDocumentation: BrokerConvenienceMiFIDTestActions.getCryptoDocumentation,
    signDocument: BrokerConvenienceMiFIDTestActions.signDocument,
    getCurrentTestScore: BrokerConvenienceMiFIDTestActions.getCurrentTestScore,
}

module.exports = connect(mapStateToProps, mapDispatchToProps)(BrokerCryptoTest)
